// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3L4P4","left":"styles_left__18CPj","desktopActions":"styles_desktopActions__13fxU","title":"styles_title__3wWAX"};